import React from 'react'
import { Email } from "react-obfuscate-email"

const MailTo = ({ classes = '' }) => {
  return <Email 
    email="hello@billsby.com"
    className={`${classes} mail-to`}/>;
}

export default MailTo